export default __webpack_public_path__ + "static/media/CECYTEJ.7d06ba3a.webp";